// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__gpxQU","green_tag":"styles_green_tag__OYUpH","gray_tag":"styles_gray_tag__fF9Wl"};